module.exports = __webpack_public_path__ + "assets/img/22_265.97546899.jpg";